import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import DocumentUploader from "../../../../components/common/DocumentUploader";
import CreateTenderingContext, {
  TENDERING_CREATE_STEPS,
} from "../CreateTenderingContext";
import { Button } from "../../../../components";

// TODO: Add default to support edit
const ConstructionDocuments = (props) => {
  const { goBackward, goForward, details, setDetails, setCurrentStep } =
    useContext(CreateTenderingContext);
  const [drawings, setDrawings] = useState(details?.files?.drawings ?? []);
  const [perspectiveRenders, setPerspectiveRenders] = useState(
    details?.files?.perspectiveRenders ?? []
  );
  const [miscellaneous, setMiscellaneous] = useState(
    details?.files?.miscellaneous ?? []
  );

  useEffect(() => {
    setCurrentStep(TENDERING_CREATE_STEPS.DOCUMENTS);
  }, []);

  const handleGoForward = () => {
    setDetails((curr) => ({
      ...curr,
      files: {
        drawings,
        miscellaneous,
        perspectiveRenders,
      },
    }));
    goForward();
  };

  return (
    <div className="tendering-create__design-documents">
      <h3>Documents</h3>
      <div className="tendering-create__design-documents__section">
        <h4>Drawings</h4>
        <DocumentUploader
          name="drawings"
          multiple={true}
          accept=".pdf,.dwg,image/*"
          onChange={(files) => {
            setDrawings(files.map((f) => ({ file: f })));
          }}
          defaultFiles={drawings.map((f) => f.file)}
        />
      </div>
      <div className="tendering-create__design-documents__divider" />
      <div className="tendering-create__design-documents__section">
        <h4>Perspective Render</h4>
        <DocumentUploader
          name="perspectiveRender"
          multiple={true}
          accept=".pdf,.dwg,image/*"
          onChange={(files) => {
            setPerspectiveRenders(files.map((f) => ({ file: f })));
          }}
          defaultFiles={perspectiveRenders.map((f) => f.file)}
        />
      </div>
      <div className="tendering-create__design-documents__divider" />
      <div className="tendering-create__design-documents__section">
        <h4>Miscellaneous</h4>
        <DocumentUploader
          name="etc"
          multiple={true}
          accept=".pdf,.dwg,image/*"
          onChange={(files) => {
            setMiscellaneous(files.map((f) => ({ file: f })));
          }}
          defaultFiles={miscellaneous.map((f) => f.file)}
        />
      </div>
      <div className="tendering-create__design-documents__footer">
        <Button
          label="Back"
          variant={"secondary"}
          onClick={() => goBackward()}
        />
        <Button label="Next" onClick={handleGoForward} />
      </div>
    </div>
  );
};

ConstructionDocuments.propTypes = {};

export default ConstructionDocuments;
